<div class="ac-toggle-container">
    <mat-slide-toggle [(ngModel)]="acModel" #matSlideToggle
                      (ngModelChange)="onChange($event)"
                      [disabled]="ngDisabled | acFunc : validatorsService.isFieldDisabled : acInputContainerComponent?.isDisabled : acFormComponent?.isDisabled"
                      [color]="color"
                      [id]="toggleId">
        {{text}}
    </mat-slide-toggle>
</div>
